import { useState } from "react";
import useAuth from "../hooks/useAuth";
import { usePostHog } from "posthog-js/react";
export function LoginForm() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const posthog = usePostHog();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    try {
      await login(username, password);
      setUsername("");
      setPassword("");
    } catch (err) {
      setError("Couldn't sign in. Check your email and password.");
      posthog?.capture("login_failed");
    }
  }

  const handleGoogleLogin = () => {
    window.location.href = "https://movix-twcp.onrender.com/api/user/google";
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100 dark:bg-black transition-colors">
      <div className="w-96 p-6 bg-white dark:bg-zinc-900 rounded-lg shadow-md border border-transparent dark:border-zinc-800">
        <span className="font-['Barlow_Condensed'] font-semibold tracking-[0.2em] uppercase text-xs text-cyan-600 dark:text-[#2DE2C1]">
          Access
        </span>
        <h2 className="text-2xl font-['Barlow_Condensed'] font-bold mt-1 mb-2 dark:text-white">
          Login to your account
        </h2>
        <p className="text-sm text-gray-500 dark:text-zinc-400 mb-6">
          Enter your email below to login to your account.
        </p>

        {error && (
          <p className="text-sm text-rose-600 dark:text-[#FF3E7F] mb-4 font-['JetBrains_Mono']">{error}</p>
        )}

        <form onSubmit={handleSubmit}>
          <div className="flex flex-col gap-2 mb-4">
            <label className="text-sm font-medium dark:text-zinc-300">Email</label>
            <input
              type="text"
              onChange={(e) => setUsername(e.target.value)}
              value={username}
              className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-cyan-500 dark:bg-zinc-800 dark:border-zinc-700 dark:text-white transition-colors"
            />
          </div>
          <div className="flex flex-col gap-2 mb-2">
            <label className="text-sm font-medium dark:text-zinc-300">Password</label>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-cyan-500 dark:bg-zinc-800 dark:border-zinc-700 dark:text-white transition-colors"
            />
          </div>
          <div className="text-right mb-4">
            <a href="/forgot-password" className="text-sm text-cyan-600 hover:underline dark:text-[#2DE2C1]">
              Forgot your password
            </a>
          </div>
          <button
            className="w-full bg-black text-white py-2 rounded mb-2 dark:bg-white dark:text-black font-semibold hover:opacity-90 transition-opacity"
            type="submit"
          >
            Login
          </button>
        </form>

        <button
          className="w-full border py-2 rounded mb-4 dark:border-zinc-700 dark:text-white dark:hover:bg-zinc-800 transition-colors"
          onClick={handleGoogleLogin}
        >
          Login with Google
        </button>

        <p className="text-sm text-center dark:text-zinc-400">
          Don't have an account?{" "}
          <a href="/signup" className="text-cyan-600 hover:underline dark:text-[#2DE2C1]">
            Sign up
          </a>
        </p>
      </div>
    </div>
  );
}